var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"rastar-toast",class:[
    _vm.active ? 'active' : '',
    this.$Base.checkSysteam() == 'MOBILE' ? 'mrastar-toast' : 'rastar-toast' ],attrs:{"id":"toast"}},[_vm._v(" "+_vm._s(_vm.text)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }